import { ICBStartChatSessionResponse } from '../../interfaces/chatbot-api-interfaces';
import { IMessage } from '../../interfaces/component-interfaces';
import { jwtDecode } from 'jwt-decode';
import { util } from '../miaw/common';
import { DISPLAY_NAME } from '../../config/app-config';

export const transformStartChatApiResponse = (
  response: ICBStartChatSessionResponse,
): {
  message: IMessage;
  sessionId: string;
  discussionId: string;
  chatbotToken: string;
} => {
  const message: IMessage = {
    id: util.generateUUID(),
    messageContent: response.data.response.messages,
    timestamp: new Date().getTime(),
    type: 'chatbot',
    senderDisplayName: DISPLAY_NAME.CHATBOT,
    isMessageRead: false,
    showFeedback: false,
  };
  const token = response.token;
  const decoded = getChatbotSessionInfo(token);
  return {
    message,
    sessionId: decoded.sessionId || '',
    discussionId: decoded.discussionId || '',
    chatbotToken: token,
  };
};

export const getChatbotSessionInfo = (token?: string): { sessionId?: string; discussionId?: string; exp?: number } => {
  if (typeof window === 'undefined') {
    console.warn('getChatbotSessionInfo is not available in this environment.');
    return {};
  }
  if (!token) return {};

  const decoded = jwtDecode<{ discussion_id: string; session_id: string; exp: number }>(token);
  return {
    sessionId: decoded.session_id,
    discussionId: decoded.discussion_id,
    exp: decoded.exp * 1000, // Convert to milliseconds
  };
};
